// @flow
import type { FSA } from 'types/redux';
import type { TridentCampaignDetails, TargetsSearchParams } from 'types/trident-campaigns';
import { API_REQUEST } from 'middlewares/api-middleware';
import tridentCampaignsConfig from 'data/models-config/trident-campaigns';
import _ from 'lodash';

// adding TRIDENT_CAMPAIGNS after GET_ENTITIES because, it is a stateKey.
export const GET_ENTITIES = 'GET_ENTITIES_TRIDENT_CAMPAIGNS';
export function getTargets(__: string, searchParams: TargetsSearchParams): FSA {
  const countryID = parseInt(searchParams.countryID, 10);
  return {
    type: GET_ENTITIES,
    payload: {
      method: 'GET',
      url: `${_.get(tridentCampaignsConfig, 'apiPath')}/${countryID}`,
      params: searchParams,
    },
    meta: {
      [API_REQUEST]: true,
      stateKey: tridentCampaignsConfig.stateKey,
    },
  };
}

// searchTargets calls new Trident search endpoint to get campaigns
export function searchTargets(__: string, searchParams: TargetsSearchParams): FSA {
  return {
    type: GET_ENTITIES,
    payload: {
      method: 'POST',
      url: `${_.get(tridentCampaignsConfig, 'apiPath')}`,
      data: searchParams,
    },
    meta: {
      [API_REQUEST]: true,
      stateKey: tridentCampaignsConfig.stateKey,
    },
  };
}


export const GET_ENTITY = 'GET_ENTITY_TRIDENT_CAMPAIGNS';
export function getTarget(__: string, campaignID: string, params: Object): FSA {
  const countryID = parseInt(params.countryID, 10);
  return {
    type: GET_ENTITY,
    payload: {
      method: 'GET',
      url: `${_.get(tridentCampaignsConfig, 'apiPath')}/${countryID}/${campaignID}`,
      params,
    },
    meta: {
      [API_REQUEST]: true,
      stateKey: tridentCampaignsConfig.stateKey,
    },
  };
}

export const CREATE_ENTITY = 'CREATE_ENTITY_TRIDENT_CAMPAIGNS';
export function createTarget(__: string, data: TridentCampaignDetails): FSA {
  const entity = data;
  const countryID = parseInt(data.countryID, 10);
  return {
    type: CREATE_ENTITY,
    payload: {
      method: 'POST',
      url: `${_.get(tridentCampaignsConfig, 'apiPath')}/${countryID}`,
      data: entity,
    },
    meta: {
      [API_REQUEST]: true,
      stateKey: tridentCampaignsConfig.stateKey,
    },
  };
}

export const EDIT_ENTITY = 'EDIT_ENTITY_TRIDENT_CAMPAIGNS';
export function editTarget(__: string, campaignID: string, data: TridentCampaignDetails): FSA {
  // const entity = addToRules(data, EDIT_ENTITY); why are we using this?
  const entity = data;
  const countryID = parseInt(data.countryID, 10);
  return {
    type: EDIT_ENTITY,
    payload: {
      method: 'PUT',
      url: `${_.get(tridentCampaignsConfig, 'apiPath')}/${countryID}/${campaignID}`,
      data: entity,
    },
    meta: {
      [API_REQUEST]: true,
      stateKey: tridentCampaignsConfig.stateKey,
    },
  };
}
